// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".p-user-info--pc[data-v-5de6e765]{margin:-5px auto auto;width:80%}.p-user-info--pc[data-v-5de6e765] .about-carat{text-align:center}.p-user-info--pc[data-v-5de6e765] .p-user-carat{justify-content:center;padding:20px}.p-user-info--pc[data-v-5de6e765] .p-user-carat__label{font-size:18px}.p-user-info--pc[data-v-5de6e765] .p-user-carat__number,.p-user-info--pc[data-v-5de6e765] .p-user-carat__number *{font-size:24px}", ""]);
// Exports
module.exports = exports;
